import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Custom preloading strategy that preloads routes marked with `data: { preload: true }`.
 * This allows heavy routes (like signing-room with the PDF viewer) to be downloaded
 * in the background after initial navigation, improving perceived performance.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preloadedRoutes: string[] = [];

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === true) {
      // Track which routes we've preloaded for debugging
      this.preloadedRoutes.push(route.path ?? '');

      return load();
    }

    return of(null);
  }
}
